import React from "react";

const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";

const STAT_CONFIG = [
  { key: "present",         label: "Present",    color: "#00ff90" },
  { key: "absent",          label: "Absent",     color: "#f87171" },
  { key: "late",            label: "Late",       color: "#fbbf24" },
  { key: "wfh",             label: "WFH",        color: "#60a5fa" },
  { key: "exceptionsCount", label: "Exceptions", color: "#c084fc" },
];

export default function AttendanceFilters({ view, setView, filters, setFilters, kpis }) {
  const set = (k, v) => setFilters(f => ({ ...f, [k]: v }));

  return (
    <div className="rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022] p-5 space-y-4">

      {/* View tabs */}
      <div className="flex gap-2 flex-wrap">
        {[
          { key: "daily",      label: "Daily"      },
          { key: "range",      label: "Date Range" },
          { key: "exceptions", label: "Exceptions" },
        ].map(t => (
          <button key={t.key} onClick={() => setView(t.key)}
            className={`text-xs px-4 py-2 rounded-full border transition-colors ${
              view === t.key
                ? "bg-[#00ff90]/15 border-[#00ff90]/40 text-[#00ff90]"
                : "bg-transparent border-white/10 text-white/40 hover:border-[#00ff90]/20 hover:text-white/60"
            }`}>
            {t.label}
          </button>
        ))}
      </div>

      {/* Date filters */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
        {view === "daily" ? (
          <div>
            <label className={labelCls}>Date</label>
            <input type="date" className={inputCls} value={filters.date}
              onChange={e => set("date", e.target.value)} />
          </div>
        ) : (
          <>
            <div>
              <label className={labelCls}>From</label>
              <input type="date" className={inputCls} value={filters.from}
                onChange={e => set("from", e.target.value)} />
            </div>
            <div>
              <label className={labelCls}>To</label>
              <input type="date" className={inputCls} value={filters.to}
                onChange={e => set("to", e.target.value)} />
            </div>
          </>
        )}

        <div>
          <label className={labelCls}>Status</label>
          <select className={inputCls} value={filters.status}
            onChange={e => set("status", e.target.value)}>
            <option value="ALL">All</option>
            {["PRESENT","ABSENT","WFH","LEAVE","LATE"].map(s => (
              <option key={s} value={s}>{s.charAt(0) + s.slice(1).toLowerCase()}</option>
            ))}
          </select>
        </div>

        <div>
          <label className={labelCls}>Search</label>
          <input className={inputCls} placeholder="Name or role…" value={filters.search}
            onChange={e => set("search", e.target.value)} />
        </div>

        <div className="flex items-end pb-1">
          <label className="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" checked={filters.onlyAnomalies}
              onChange={e => set("onlyAnomalies", e.target.checked)}
              className="w-4 h-4 rounded border-[#00ff90]/30 accent-[#00ff90]" />
            <span className="text-sm text-white/60">Anomalies only</span>
          </label>
        </div>
      </div>

      {/* KPI pills */}
      {kpis && (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 pt-1 border-t border-white/5">
          {STAT_CONFIG.map(({ key, label, color }) => (
            <div key={key} className="rounded-lg border border-white/5 bg-white/3 p-3 text-center">
              <p className="text-lg font-bold" style={{ color }}>{kpis[key] ?? 0}</p>
              <p className="text-xs text-white/30 mt-0.5">{label}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}